export default "__VITE_ASSET__DPBt7Ggp__"